export default "__VITE_ASSET__l56h8zxm__"